export default __webpack_public_path__ + "static/summer_containers95-c6760219b18ae8972c2d07939a53828a.webp";